import React from 'react';

const MailingSkeleton = () => {
  return (
    <div className='w-full mt-10'>
      <div className='w-full flex flex-col gap-4'>
        <div className='w-full flex flex-col md:gap-4 md:flex-row'>
          <div className='skeleton-loader w-full h-[60px]'></div>
        </div>
        <div className='skeleton-loader w-full mt-10 h-[300px]'></div>
        <div className='skeleton-loader w-full mt-6 h-[480px]'></div>
        <div className='flex justify-end mt-6'>
          <div className='skeleton-loader w-32 h-10'></div>
        </div>
      </div>
    </div>
  );
};

export default MailingSkeleton;
